
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  props: { imageUrl: String, modalId: String },
})
export default class OpenImage extends Vue {
  public static openModal(modalId: string, urlImage: string) {
    var modal: any = document.getElementById(modalId);
    var img: any = document.getElementById("imgId");
    modal.style.display = "flex";
    img.src = urlImage;
  }

  public closeModal() {
    var modal: any = document.getElementById(this.$props.modalId);
    modal.style.display = "none";
  }
}
